import * as css from './StatusLabel.css';
import {StatusColor} from './StatusLabel.css';

export type {StatusColor};

interface StatusLabelProps {
    text: string;
    color: StatusColor;
    details?: string;
    image?: string;
    imagePosition?: 'start' | 'end';
    imageShiftY?: string;
    imageHeight?: string;
    imageRotate?: string;
    desaturate?: boolean;
    'data-cy'?: string;
}

function StatusLabel({text, color, details, image, imagePosition = 'start', imageShiftY, imageHeight, imageRotate, desaturate, 'data-cy': dataCy = 'status-label'}: StatusLabelProps) {
    const img = image && <css.image src={image} alt="" aria-hidden $shiftY={imageShiftY} $height={imageHeight} $rotate={imageRotate} $desaturate={desaturate} />;
    return (
        <css.strip $color={color} data-cy={dataCy}>
            {imagePosition === 'start' && img}
            <span>{text}</span>
            {details && <css.details>{details}</css.details>}
            {imagePosition === 'end' && img}
        </css.strip>
    );
}

export default StatusLabel;
